<template>
   <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="近7天数据" name="type7"></el-tab-pane>
        <el-tab-pane label="近30天数据" name="type30"></el-tab-pane>
        <el-tab-pane label="全部" name="typeall"></el-tab-pane>
      </el-tabs>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        

        <el-form-item label="商品关键词"><el-input size="small" v-model="searchForm.product_name" placeholder="关键词搜索"></el-input></el-form-item>
        <el-form-item label="供应商id或名字"><el-input size="small" v-model="searchForm.supply_key" placeholder="供应商id或名字搜索"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>


    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"   >
          <el-table-column prop="product_name" label="产品" width="300px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image?scope.row.image.file_path:error_img" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="price">￥{{ scope.row.product_price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="supply_id" label="所属供应商" width="300px">
            <template slot-scope="scope">
               <div class="name" v-if="scope.row.supply_id>0">
                  <p>商家名称：{{scope.row.supply.name}}</p>
                  <p>商家ID：{{scope.row.supply_id}}</p>
                </div>
                <div v-else>平台</div>
            </template>
          </el-table-column>

          <el-table-column prop="sales_volume" label="销售额"></el-table-column>
          <el-table-column prop="total_sales_num" label="销量"></el-table-column>
          
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

  </div>
</template>

<script>
  import StatisticsApi from '@/api/statistics.js';
  export default{
    components:{
    },
    data(){
      return{
        /*是否正在加载*/
        activeName: 'type7',
        loading: true,
        tableData:[],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索参数*/
        searchForm: {
          product_name: '',
          supply_key: '',
        },
        /*数据对象*/
        dataModel:{}
      }
    },
    provide: function () {
      return {
        dataModel: this.dataModel
      }
    },
    created() {

      this.getData();
    },
    methods:{
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.loading = true;
        self.curPage = val;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.pageSize = val;
        this.getData();
      },

      /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getData();
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getData();
      },

      /*获取数据*/
      getData() {
        let self = this;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.type = self.activeName;
        self.loading = true;
        StatisticsApi.getProductSales(Params, true)
          .then(res => {
            self.tableData = res.data.list.data;
            self.totalDataNumber = res.data.list.total;
            self.loading = false;
          })
          .catch(error => {});
      }

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/statistics/productsales/index.vue